import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useShowModal } from 'hooks'

const CreateBusinessActivityButton = () => {
  const { showModal } = useShowModal({ modalType: Modals.BUSINESS_ENTITY_MODAL })

  const showCreateModal = () => showModal()

  return (
    <Button layout={BUTTON_LAYOUTS.PURPLE} onClick={showCreateModal} style={CREATE_BUTTON_STYLE}>
      Create Business Activity
    </Button>
  )
}

export default CreateBusinessActivityButton
